<script lang="ts">
	import { PUBLIC_PATH } from '$env/static/public';
	export let title = 'Terms & Conditions';
</script>

<div
	id="tnc-header"
	class="relative w-full overflow-hidden bg-background-alt shadow-[0px_4px_4px_0px_rgba(197,197,197,0.25)]"
>
	<div
		class="absolute inset-0 pointer-events-none bg-repeat"
		style="background-image: url('{PUBLIC_PATH}/images/grid-line-blue.svg');"
	></div>
	<header
		class="relative z-10 mx-auto max-w-8xl px-padding_lg py-8 lg:px-20 text-left text-[1.5rem] font-semibold leading-[2.25rem] text-black-title tracking-[-0.0625rem] lg:text-[3rem] lg:leading-[3.5rem]"
	>
		<h1>{title}</h1>
	</header>
</div>
